import getSplashApiClient from 'lib/SplashApiClient/singleton';
import axios from 'axios';
import { getInstance as getBootstrap } from 'utils/bootstrap';

const thirdPartyTrackingManagerServiceUrl = getBootstrap().get('thirdPartyTrackingManager.serviceUrl');

export default class ThirdPartyTrackingManagerApiClient {
    /**
     * @param {SplashApiClient} apiClient
     * @param {number | string} eventId
     */
    constructor(apiClient, eventId) {
        this.apiClient = apiClient;
        this.eventId = eventId;
        this.proxyHeaders = {
            headers: {
                'X-Splash-Event-Id': eventId,
            },
        };
    }

    /**
     * Get the list of active trackers associated with this event page
     * @async
     *
     * @param {string} [options.pageTypes = ''] - filter by page type
     *
     * @returns {Array<Object>} - list of trackers
     */
    getTrackerList = async ({ pageTypes = '' } = {}) => {
        try {
            const publicTrackerListUrl = `${thirdPartyTrackingManagerServiceUrl}/api/v1/events/${this.eventId}/trackers`;

            const response = await axios.get(publicTrackerListUrl, {
                params: {
                    ...(pageTypes ? { pageTypes } : {}),
                },
            });

            return response.data.data;
        } catch {
            return [];
        }
    };

    /**
     * Get the list of all trackers associated with this event page
     * @async
     *
     * @param {boolean} [options.includeInactive = false] - include inactive trackers
     * @param {string} [options.pageTypes = ''] - filter by page type
     *
     * @returns {Array<Object>} - list of trackers
     */
    getAdminTrackerList = async ({ includeInactive = false, pageTypes = '' } = {}) => {
        const adminTrackerListUrl = `/tptm/admin/v1/events/${this.eventId}/trackers`;
        const params = {
            includeInactive,
            ...(pageTypes ? { pageTypes } : {}),
        };

        const response = await this.apiClient.get(adminTrackerListUrl, params, { ...this.proxyHeaders });

        return response.data;
    };

    deleteTracker = async ({ trackerId }) => {
        const deleteTrackerUrl = `/tptm/admin/v1/trackers/${trackerId}`;
        const response = await this.apiClient.delete(deleteTrackerUrl, {}, { ...this.proxyHeaders });

        return response.data;
    };

    createNewTracker = async ({ trackerData }) => {
        const createNewTrackerUrl = `/tptm/admin/v1/trackers`;
        const payload = Array.isArray(trackerData) ? trackerData : [trackerData];

        const response = await this.apiClient.post(createNewTrackerUrl, payload, { ...this.proxyHeaders });

        return response.data;
    };

    updateTracker = async ({ trackerData }) => {
        const updateTrackerUrl = `/tptm/admin/v1/trackers/${trackerData.id}`;

        const response = await this.apiClient.patch(updateTrackerUrl, trackerData, { ...this.proxyHeaders });

        return response.data;
    };
}

export const getThirdPartyTrackingManagerApiClient = (eventId) =>
    new ThirdPartyTrackingManagerApiClient(getSplashApiClient(), eventId);
